import { Sidebar } from './Sidebar';
import { Toaster } from 'sonner';
import { UILabelsProvider } from '../../context/UILabelsContext';
import { useAuth } from '../../context/AuthContext';

const TOAST_OPTIONS = {
  style: { fontFamily: 'Fira Sans, sans-serif' },
};

export const DashboardLayout = ({ children }) => {
  const { tenant } = useAuth();
  return (
    <UILabelsProvider tenantId={tenant?.id} isPublic={false}>
    <div className="flex min-h-screen bg-[#F9F8F6]">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <div className="p-8">
          {children}
        </div>
      </main>
      <Toaster 
        position="top-right" 
        toastOptions={TOAST_OPTIONS}
      />
    </div>
    </UILabelsProvider>
  );
};
